import React from 'react';
import { useHits } from 'react-instantsearch';

import SearchVehicleCard from './SearchVehicleCard';
import { ChevronIconRight } from '../../common/Icons';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { SWIPER_CONFIG } from '../../../config/swiper';

export default function VehicleHits({ vehicleOverviewUrl, swiperPagination, query }) {
    const { hits } = useHits();

    if (hits.length === 0) return null;

    const topHit = hits[0];
    const topBrand = topHit?.brand;
    const topModel = topHit?.model;
    const queryLower = (query || '').toLowerCase();
    const queryWords = queryLower.split(/\s+/).filter(Boolean);
    const queryMatchesModel = topModel && queryLower.includes(topModel.toLowerCase());

    let overviewUrl = vehicleOverviewUrl;
    if (vehicleOverviewUrl && topBrand) {
        overviewUrl += `?brand[]=${encodeURIComponent(topBrand)}`;
        if (queryMatchesModel) {
            overviewUrl += `&model[${encodeURIComponent(topBrand)}][]=${encodeURIComponent(topModel)}`;
        }

        const fuel = topHit?.attributes?.brandstof || topHit?.fuel || '';
        if (fuel && queryWords.includes(fuel.toLowerCase())) {
            overviewUrl += `&brandstof[]=${encodeURIComponent(fuel.charAt(0).toUpperCase() + fuel.slice(1))}`;
        }

        const bodywork = topHit?.attributes?.carrosserie || topHit?.bodywork || '';
        if (bodywork && queryWords.includes(bodywork.toLowerCase())) {
            overviewUrl += `&carrosserie[]=${encodeURIComponent(bodywork)}`;
        }
    }

    return (
        <div className="col-12">
            <div className="d-flex justify-content-between align-items-center mb-8 flex-wrap-reverse gap-2">
                <p className="font-weight-bold mb-0">{window.Translator.trans('app.header.search.results.popular_vehicles')}</p>
                {overviewUrl && (
                    <div className="d-flex align-items-center gap-1">
                        <a className="btn p-0 text--14" href={overviewUrl}>
                            {window.Translator.trans('app.header.search.results.vehicle_overview')}
                        </a>
                        <ChevronIconRight className="icon" />
                    </div>
                )}
            </div>
            <Swiper
                {...SWIPER_CONFIG}
                modules={[Pagination]}
                className={'swiper-search-modal'}
                pagination={{
                    el: swiperPagination,
                    clickable: false,
                }}
                breakpoints={{
                    1: {
                        slidesPerView: hits.length > 1 ? 1.25 : 1,
                        spaceBetween: 5,
                    },
                    768: {
                        slidesPerView: hits.length > 2 ? 2.25 : 2,
                        spaceBetween: 10,
                    },
                    992: {
                        slidesPerView: hits.length > 2 ? 2.25 : 2,
                        spaceBetween: 16,
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                }}
            >
                {hits.map((vehicle) => (
                    <SwiperSlide key={vehicle.id || vehicle.objectID}>
                        <SearchVehicleCard vehicle={vehicle} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
